<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div class="background text app-content-container">
  <app-topbar
    [title]="topbarText"
    [topbarView]="TopbarView.BLUEPRINT_HOME"
    [imageFilePath]="topbarImage"
    (urlNavigate)="goToUrl($event)"
  ></app-topbar>

  @if (selectedMselId) {
    @if (!canViewAssessorPage) {
      <div class="no-access-message">
        <mat-icon fontIcon="mdi-alert-circle-outline" style="font-size: 48px; width: 48px; height: 48px;"></mat-icon>
        <h3>Access Denied</h3>
        <p>You need at least Editor role on this MSEL to view the assessor page.</p>
      </div>
    } @else {
      <app-assessor-view
        [loggedInUserId]="loggedInUserId"
        [userTheme]="userTheme$ | async"
        [canEditCheckboxes]="canEditAssessorPage"
      ></app-assessor-view>
    }
  }
</div>
